const mapJson = {
   'cardResumenTerrestrePublic': [
      {
         label: 'company',
         infoTool: true,
         arrayInfoTool: [
            {
               label: "phone",
               key: "CustomerTelephone"
            }, {
               label: "city",
               key: "CustomerCity"
            },
            {
               label: "state",
               key: "CustomerState"
            },
            {
               label: "country",
               key: "CustomerCountry"
            },
         ],
         data: [
            {
               value: '',
               key: 'CustomerName',
               label: 'name',
               bold: false,
               info: true,
            },
            {
               value: '',
               key: 'CustomerAddress',
               label: 'address',
               bold: false
            },
         ]
      },
      {
         label: 'route',
         data: [
            {
               value: '',
               key: 'POL',
               label: 'origin',
               bold: false
            },
            {
               value: '',
               key: 'POD',
               label: 'destination',
               bold: false
            },
            {
               value: '',
               key: 'Route',
               label: 'route',
               bold: false
            },
            {
               value: '',
               key: 'BookingConfirmationDate',
               label: 'booking_confirmed',
               bold: false
            }, {
               value: '',
               key: 'PickupDate',
               label: 'pickup_date',
               bold: false
            },
            // {
            //    value: '',
            //    key: 'StartHandover',
            //    label: 'start_handover',
            //    bold: false
            // },
            {
               value: '',
               key: 'ETD',
               label: 'etd',
               bold: false
            },
            {
               value: '',
               key: 'ETA',
               label: 'eta',
               bold: false
            },
            // {
            //    value: '',
            //    key: 'NewETD',
            //    label: 'new_etd',
            //    bold: false
            // },
            // {
            //    value: '',
            //    key: 'NewETA',
            //    label: 'new_eta',
            //    bold: false
            // },
            {
               value: '',
               key: 'ATD',
               label: 'ATD',
               bold: false
            },
            {
               value: '',
               key: 'ATA',
               label: 'ATA',
               bold: false
            },
            // {
            //    value: '',
            //    key: 'FinishHandover',
            //    label: 'finish_handover',
            //    bold: false
            // },
            {
               value: '',
               key: 'ArrivalBorderDate',
               label: 'arrival_border_crossing',
               bold: false
            },
            {
               value: '',
               key: 'ArrivalCustomsDate',
               label: 'arrival_at_custom',
               bold: false
            },
            {
               value: '',
               key: 'CustomsReleasedDate',
               label: 'customs_clearence',
               bold: false
            },
            {
               value: '',
               key: 'BorderDepartureDate',
               label: 'departed_border_creossing',
               bold: false
            },
            {
               value: '',
               key: 'DeliveryDate',
               label: 'delivery_date',
               bold: false
            },
         ]
      },
      {
         label: 'General',
         data: [
            {
               value: '',
               key: 'TransportOrderNo',
               label: 'transport_order_num',
               primary: false,
               otro: false
            },
            {
               value: '',
               key: 'TransportPlanNo',
               label: 'transport_plan_num',
               primary: false,
               otro: false,
               // link: '/tp-detail-view/',
               key2: 'TransportPlanId',
            },
            {
               value: '',
               key: 'BookingNo',
               label: 'booking_num',
               primary: false,
               otro: true,
            },
            {
               value: '',
               key: 'CustomertRef',
               label: 'reference',
               primary: false,
               otro: false
            },
            {
               value: '',
               key: 'TransportMode',
               label: 'transport_mode',
               bold: false,
               info: true,
               tooltip: ''
            },
            {
               value: '',
               key: 'ServiceType',
               label: 'service_type',
               primary: false,
               otro: false
            },
            {
               value: '',
               key: 'ShipmentType',
               label: 'shipment_type',
               primary: false,
               otro: false
            },
            {
               value: '',
               key: 'FreightTerm',
               label: 'freight_terms',
               primary: false,
               otro: true,
            },
            {
               value: '',
               key: 'IncotermCode',
               label: 'incoterm',
               primary: false,
               otro: true,
            },
            {
               value: '',
               key: 'MBL_AWB_PRO',
               label: 'PRO No.',
               primary: false,
               otro: true,
            },
            {
               value: '',
               key: 'Voyage_FlightNumber',
               label: 'truck_num',
               primary: false,
               otro: true,
            },
            // {
            //    value: '',
            //    key: 'DutyPaidDate',
            //    label: 'duty_paid_date',
            //    primary: false,
            //    otro: true,
            // },
            // {
            //    value: '',
            //    key: 'EntryNumber',
            //    label: 'entry_number',
            //    primary: false,
            //    otro: true,
            // }, 
            {
               value: '',
               key: 'DaysInTransit',
               label: 'days_in_transit',
               primary: false,
               otro: true,
            },
            // {
            //    value: '',
            //    key: 'AscertainedTotal',
            //    label: 'ascertained_total',
            //    primary: false,
            //    otro: true,
            // }
         ]
      },
      {
         label: 'cargo',
         data: [
            {
               value: '',
               key: 'TotalWeight',
               label: 'chargable_weight',
               primary: false,
               otro: false,
               format: 'weight'
            },
            {
               value: '',
               key: 'TotalGrossWeight',
               label: 'gross_weight',
               primary: false,
               otro: false,
               format: 'weight'
            },
            {
               value: '',
               key: 'TotalVolume',
               label: 'total_volume',
               primary: false,
               otro: false,
               format: 'dimension'
            },
            // {
            //    value: '',
            //    key: 'DeclaredValue',
            //    label: 'shipment_total_value',
            //    primary: false,
            //    otro: false
            // },
            // {
            //    value: '',
            //    key: 'declaredValueCurrency',
            //    label: 'currency',
            //    primary: false,
            //    otro: false
            // },
            {
               value: '',
               key: 'Totalpieces',
               label: 'total_píeces',
               primary: false,
               otro: false
            },
            {
               value: '',
               key: 'TotalPackages',
               label: 'total_amount_packages',
               primary: false,
               otro: false
            },
            {
               value: '',
               key: 'DGR',
               label: 'dgr',
               primary: false,
               otro: true,
            },
            {
               value: '',
               key: 'UN',
               label: 'UN',
               primary: false,
               otro: true,
            },
            {
               value: '',
               key: 'Class',
               label: 'class',
               primary: false,
               otro: true,
            }
         ]
      }
   ],
   'cardResumenAereoPublic': [
      {
         label: 'company',
         infoTool: true,
         arrayInfoTool: [
            {
               label: "phone",
               key: "CustomerTelephone"
            }, {
               label: "city",
               key: "CustomerCity"
            },
            {
               label: "state",
               key: "CustomerState"
            },
            {
               label: "country",
               key: "CustomerCountry"
            },
         ],
         data: [
            {
               value: '',
               key: 'CustomerName',
               label: 'name',
               bold: false,
               info: true,
            },
            {
               value: '',
               key: 'CustomerAddress',
               label: 'address',
               bold: false
            },
         ]
      },
      {
         label: 'route',
         data: [
            {
               value: '',
               key: 'POL',
               label: 'origin',
               bold: false
            },
            {
               value: '',
               key: 'POD',
               label: 'destination',
               bold: false
            },
            {
               value: '',
               key: 'Route',
               label: 'route',
               bold: false
            },
            {
               value: '',
               key: 'BookingConfirmationDate',
               label: 'booking_confirmed',
               bold: false
            },
            {
               value: '',
               key: 'PickupDate',
               label: 'pickup_date',
               bold: false
            }, {
               value: '',
               key: 'ReceivedDestinationAirport',
               label: 'received_airport',
               bold: false
            },
            // {
            //    value: '',
            //    key: 'StartHandover',
            //    label: 'start_handover',
            //    bold: false
            // },
            {
               value: '',
               key: 'ETD',
               label: 'etd',
               bold: false
            },
            {
               value: '',
               key: 'ETA',
               label: 'eta',
               bold: false
            },
            // {
            //    value: '',
            //    key: 'NewETD',
            //    label: 'new_etd',
            //    bold: false
            // },
            // {
            //    value: '',
            //    key: 'NewETA',
            //    label: 'new_eta',
            //    bold: false
            // },
            {
               value: '',
               key: 'ATD',
               label: 'ATD',
               bold: false
            },
            {
               value: '',
               key: 'ATA',
               label: 'ATA',
               bold: false
            },
            // {
            //    value: '',
            //    key: 'FinishHandover',
            //    label: 'finish_handover',
            //    bold: false
            // },
            {
               value: '',
               key: 'ArrivalCustomsDate',
               label: 'received_destination_airport',
               bold: false
            },
            {
               value: '',
               key: 'CustomsReleasedDate',
               label: 'delivered_destination_airport',
               bold: false
            },
            {
               value: '',
               key: 'DeliveryDate',
               label: 'delivery_date',
               bold: false
            },
         ]
      },
      {
         label: 'General',
         data: [
            {
               value: '',
               key: 'TransportOrderNo',
               label: 'transport_order_num',
               primary: false,
               otro: false
            },
            {
               value: '',
               key: 'TransportPlanNo',
               label: 'transport_plan_num',
               primary: false,
               otro: false,
               // link: '/tp-detail-view/',
               key2: 'TransportPlanId',
            },

            // {
            //    value: '',
            //    key: 'ShipmentProgram',
            //    label: 'shipment_program',
            //    primary: false,
            //    otro: true,
            // },
            {
               value: '',
               key: 'BookingNo',
               label: 'booking_num',
               primary: false,
               otro: true,
            },
            {
               value: '',
               key: 'CustomertRef',
               label: 'reference',
               primary: false,
               otro: false
            },
            {
               value: '',
               key: 'TransportMode',
               label: 'transport_mode',
               bold: false,
               info: true,
               tooltip: ''
            },
            {
               value: '',
               key: 'ServiceType',
               label: 'service_type',
               primary: false,
               otro: false
            },

            {
               value: '',
               key: 'ShipmentType',
               label: 'shipment_type',
               primary: false,
               otro: false
            },

            {
               value: '',
               key: 'FreightTerm',
               label: 'freight_terms',
               primary: false,
               otro: true,
            },
            {
               value: '',
               key: 'IncotermCode',
               label: 'incoterm',
               primary: false,
               otro: true,
            },
            {
               value: '',
               key: 'HBL_HAWB',
               label: 'hawb',
               primary: false,
               otro: true,
            },
            // {
            //    value: '',
            //    key: 'MBL_AWB_PRO',
            //    label: 'AWB',
            //    primary: false,
            //    otro: true,
            // },
            // {
            //    value: '',
            //    key: '3PL',
            //    label: '3pl',
            //    primary: false,
            //    otro: true,
            // },
            // {
            //    value: '',
            //    key: '3PLRef',
            //    label: 'reference_3pl',
            //    primary: false,
            //    otro: true,
            // },
            // {
            //    value: '',
            //    key: 'Carrier',
            //    label: 'carrier',
            //    primary: false,
            //    otro: true,
            // },
            {
               value: '',
               key: 'Voyage_FlightNumber',
               label: 'flight_no',
               primary: false,
               otro: true,
            },
            // {
            //    value: '',
            //    key: 'DutyPaidDate',
            //    label: 'duty_paid_date',
            //    primary: false,
            //    otro: true,
            // },
            // {
            //    value: '',
            //    key: 'EntryNumber',
            //    label: 'entry_number',
            //    primary: false,
            //    otro: true,
            // },
            {
               value: '',
               key: 'DaysInTransit',
               label: 'days_in_transit',
               primary: false,
               otro: true,
            },
            // {
            //    value: '',
            //    key: 'AscertainedTotal',
            //    label: 'ascertained_total',
            //    primary: false,
            //    otro: true,
            // }
         ]
      },
      {
         label: 'cargo',
         data: [
            {
               value: '',
               key: 'TotalWeight',
               label: 'chargable_weight',
               primary: false,
               otro: false,
               format: 'weight'
            },
            {
               value: '',
               key: 'TotalGrossWeight',
               label: 'gross_weight',
               primary: false,
               otro: false,
               format: 'weight'
            },
            // {
            //    value: '',
            //    key: 'DeclaredValue',
            //    label: 'shipment_total_value',
            //    primary: false,
            //    otro: false
            // },
            // {
            //    value: '',
            //    key: 'declaredValueCurrency',
            //    label: 'currency',
            //    primary: false,
            //    otro: false
            // },
            {
               value: '',
               key: 'Totalpieces',
               label: 'total_píeces',
               primary: false,
               otro: false
            },
            {
               value: '',
               key: 'TotalPackages',
               label: 'total_amount_packages',
               primary: false,
               otro: false
            },
            {
               value: '',
               key: 'DGR',
               label: 'dgr',
               primary: false,
               otro: true,
            },
            {
               value: '',
               key: 'UN',
               label: 'UN',
               primary: false,
               otro: true,
            },
            {
               value: '',
               key: 'Class',
               label: 'class',
               primary: false,
               otro: true,
            }
         ]
      }
   ],
   'cardResumenMaritimoPublic': [
      {
         label: 'company',
         infoTool: true,
         arrayInfoTool: [
            {
               label: "phone",
               key: "CustomerTelephone"
            }, {
               label: "city",
               key: "CustomerCity"
            },
            {
               label: "state",
               key: "CustomerState"
            },
            {
               label: "country",
               key: "CustomerCountry"
            },
         ],
         data: [
            {
               value: '',
               key: 'CustomerName',
               label: 'name',
               bold: false,
               info: true,
            },
            {
               value: '',
               key: 'CustomerAddress',
               label: 'address',
               bold: false
            },
         ]
      },
      {
         label: 'route',
         data: [
            {
               value: '',
               key: 'POL',
               label: 'origin',
               bold: false
            },
            {
               value: '',
               key: 'POD',
               label: 'destination',
               bold: false
            },
            {
               value: '',
               key: 'Route',
               label: 'route',
               bold: false
            },
            {
               value: '',
               key: 'BookingConfirmationDate',
               label: 'booking_confirmed',
               bold: false
            },
            {
               value: '',
               key: 'PickupDate',
               label: 'pickup_date',
               bold: false
            },
            // {
            //    value: '',
            //    key: 'StartHandover',
            //    label: 'start_handover',
            //    bold: false
            // },
            {
               value: '',
               key: 'ETD',
               label: 'etd',
               bold: false
            },
            {
               value: '',
               key: 'ETA',
               label: 'eta',
               bold: false
            },
            // {
            //    value: '',
            //    key: 'NewETD',
            //    label: 'new_etd',
            //    bold: false
            // },
            // {
            //    value: '',
            //    key: 'NewETA',
            //    label: 'new_eta',
            //    bold: false
            // },
            {
               value: '',
               key: 'ATD',
               label: 'ATD',
               bold: false
            },
            {
               value: '',
               key: 'ATA',
               label: 'ATA',
               bold: false
            },
            // {
            //    value: '',
            //    key: 'FinishHandover',
            //    label: 'finish_handover',
            //    bold: false
            // },
            {
               value: '',
               key: 'DeliveryDate',
               label: 'delivery_date',
               bold: false
            },
         ]
      },
      {
         label: 'General',
         data: [
            {
               value: '',
               key: 'TransportOrderNo',
               label: 'transport_order_num',
               primary: false,
               otro: false
            },
            {
               value: '',
               key: 'TransportPlanNo',
               label: 'transport_plan_num',
               primary: false,
               otro: false,
               // link: '/tp-detail-view/',
               key2: 'TransportPlanId',
            },
            // {
            //    value: '',
            //    key: 'ShipmentProgram',
            //    label: 'shipment_program',
            //    primary: false,
            //    otro: true,
            // },
            {
               value: '',
               key: 'BookingNo',
               label: 'booking_num',
               primary: false,
               otro: true,
            },
            {
               value: '',
               key: 'CustomertRef',
               label: 'reference',
               primary: false,
               otro: false
            },
            {
               value: '',
               key: 'TransportMode',
               label: 'transport_mode',
               bold: false,
               info: true,
               tooltip: ''
            },
            {
               value: '',
               key: 'ServiceType',
               label: 'service_type',
               primary: false,
               otro: false
            },

            {
               value: '',
               key: 'ShipmentType',
               label: 'shipment_type',
               primary: false,
               otro: false
            },

            {
               value: '',
               key: 'FreightTerm',
               label: 'freight_terms',
               primary: false,
               otro: true,
            },
            {
               value: '',
               key: 'IncotermCode',
               label: 'incoterm',
               primary: false,
               otro: true,
            },
            {
               value: '',
               key: 'HBL_HAWB',
               label: 'hbl',
               primary: false,
               otro: true,
            },
            // {
            //    value: '',
            //    key: 'MBL_AWB_PRO',
            //    label: 'mbl',
            //    primary: false,
            //    otro: true,
            // },
            // {
            //    value: '',
            //    key: '3PL',
            //    label: '3pl',
            //    primary: false,
            //    otro: true,
            // },
            // {
            //    value: '',
            //    key: '3PLRef',
            //    label: 'reference_3pl',
            //    primary: false,
            //    otro: true,
            // },
            // {
            //    value: '',
            //    key: 'Carrier',
            //    label: 'carrier',
            //    primary: false,
            //    otro: true,
            // },
            {
               value: '',
               key: 'Vessel',
               label: 'vessel',
               primary: false,
               otro: true,
            },
            // {
            //    value: '',
            //    key: 'Voyage_FlightNumber',
            //    label: 'voyage',
            //    primary: false,
            //    otro: true,
            // },
            // {
            //    value: '',
            //    key: 'DutyPaidDate',
            //    label: 'duty_paid_date',
            //    primary: false,
            //    otro: true,
            // }, 
            // {
            //    value: '',
            //    key: 'EntryNumber',
            //    label: 'entry_number',
            //    primary: false,
            //    otro: true,
            // }, 
            {
               value: '',
               key: 'DaysInTransit',
               label: 'days_in_transit',
               primary: false,
               otro: true,
            }, 
            // {
            //    value: '',
            //    key: 'AscertainedTotal',
            //    label: 'ascertained_total',
            //    primary: false,
            //    otro: true,
            // }
         ]
      },
      {
         label: 'cargo',
         data: [
            {
               value: '',
               key: 'TotalWeight',
               label: 'chargable_weight',
               primary: false,
               otro: false,
               format: 'weight'
            },
            {
               value: '',
               key: 'TotalGrossWeight',
               label: 'gross_weight',
               primary: false,
               otro: false,
               format: 'weight'
            },
            {
               value: '',
               key: 'TotalVolume',
               label: 'total_volume',
               primary: false,
               otro: false,
               format: 'dimension'
            },
            // {
            //    value: '',
            //    key: 'DeclaredValue',
            //    label: 'shipment_total_value',
            //    primary: false,
            //    otro: false
            // },
            // {
            //    value: '',
            //    key: 'declaredValueCurrency',
            //    label: 'currency',
            //    primary: false,
            //    otro: false
            // },
            {
               value: '',
               key: 'Totalpieces',
               label: 'total_píeces',
               primary: false,
               otro: false
            },
            {
               value: '',
               key: 'TotalPackages',
               label: 'total_amount_packages',
               primary: false,
               otro: false
            },
            {
               value: '',
               key: 'TotalContainers',
               label: 'total_containers',
               primary: false,
               otro: false
            },
            {
               value: '',
               key: 'TotalTEUS',
               label: 'total_teus',
               primary: false,
               otro: true,
            },
            {
               value: '',
               key: 'DGR',
               label: 'dgr',
               primary: false,
               otro: true,
            },
            {
               value: '',
               key: 'UN',
               label: 'UN',
               primary: false,
               otro: true,
            },
            {
               value: '',
               key: 'Class',
               label: 'class',
               primary: false,
               otro: true,
            }
         ]
      }
   ],
   'cardResumenRailPublic': [
      {
         label: 'company',
         infoTool: true,
         arrayInfoTool: [
            {
               label: "phone",
               key: "CustomerTelephone"
            }, {
               label: "city",
               key: "CustomerCity"
            },
            {
               label: "state",
               key: "CustomerState"
            },
            {
               label: "country",
               key: "CustomerCountry"
            },
         ],
         data: [
            {
               value: '',
               key: 'CustomerName',
               label: 'name',
               bold: false,
               info: true,
            },
            {
               value: '',
               key: 'CustomerAddress',
               label: 'address',
               bold: false
            },
         ]
      },
      {
         label: 'route',
         data: [
            {
               value: '',
               key: 'POL',
               label: 'origin',
               bold: false
            },
            {
               value: '',
               key: 'POD',
               label: 'destination',
               bold: false
            },
            {
               value: '',
               key: 'Route',
               label: 'route',
               bold: false
            },
            {
               value: '',
               key: 'BookingConfirmationDate',
               label: 'booking_confirmed',
               bold: false
            }, {
               value: '',
               key: 'PickupDate',
               label: 'pickup_date',
               bold: false
            },
            {
               value: '',
               key: 'ETD',
               label: 'etd',
               bold: false
            },
            {
               value: '',
               key: 'ETA',
               label: 'eta',
               bold: false
            },
            // {
            //    value: '',
            //    key: 'NewETD',
            //    label: 'new_etd',
            //    bold: false
            // },
            // {
            //    value: '',
            //    key: 'NewETA',
            //    label: 'new_eta',
            //    bold: false
            // },
            {
               value: '',
               key: 'ATD',
               label: 'ATD',
               bold: false
            },
            {
               value: '',
               key: 'ATA',
               label: 'ATA',
               bold: false
            },
            // {
            //    value: '',
            //    key: 'FinishHandover',
            //    label: 'finish_handover',
            //    bold: false
            // },
            // {
            //    value: '',
            //    key: 'ArrivalBorderDate',
            //    label: 'arrival_border_crossing',
            //    bold: false
            // },
            // {
            //    value: '',
            //    key: 'ArrivalCustomsDate',
            //    label: 'arrival_at_custom',
            //    bold: false
            // },
            // {
            //    value: '',
            //    key: 'CustomsReleasedDate',
            //    label: 'customs_clearence',
            //    bold: false
            // },
            // {
            //    value: '',
            //    key: 'BorderDepartureDate',
            //    label: 'departed_border_creossing',
            //    bold: false
            // },
            {
               value: '',
               key: 'DeliveryDate',
               label: 'delivery_date',
               bold: false
            },
         ]
      },
      {
         label: 'General',
         data: [
            {
               value: '',
               key: 'TransportOrderNo',
               label: 'transport_order_num',
               primary: false,
               otro: false
            },
            {
               value: '',
               key: 'TransportPlanNo',
               label: 'transport_plan_num',
               primary: false,
               otro: false,
               // link: '/tp-detail-view/',
               key2: 'TransportPlanId',
            },
            // {
            //    value: '',
            //    key: 'ShipmentProgram',
            //    label: 'shipment_program',
            //    primary: false,
            //    otro: true,
            // },
            {
               value: '',
               key: 'BookingNo',
               label: 'booking_num',
               primary: false,
               otro: true,
            },
            {
               value: '',
               key: 'CustomertRef',
               label: 'reference',
               primary: false,
               otro: false
            },
            {
               value: '',
               key: 'TransportMode',
               label: 'transport_mode',
               bold: false,
               info: true,
               tooltip: ''
            },
            {
               value: '',
               key: 'ServiceType',
               label: 'service_type',
               primary: false,
               otro: false
            },
            {
               value: '',
               key: 'ShipmentType',
               label: 'shipment_type',
               primary: false,
               otro: false
            },
            {
               value: '',
               key: 'FreightTerm',
               label: 'freight_terms',
               primary: false,
               otro: true,
            },
            {
               value: '',
               key: 'IncotermCode',
               label: 'incoterm',
               primary: false,
               otro: true,
            },
            {
               value: '',
               key: 'MBL_AWB_PRO',
               label: 'MBL',
               primary: false,
               otro: true,
            },
            // {
            //    value: '',
            //    key: 'MBL_AWB_PRO',
            //    label: 'PRO No.',
            //    primary: false,
            //    otro: true,
            // },
            // {
            //    value: '',
            //    key: '3PL',
            //    label: '3pl',
            //    primary: false,
            //    otro: true,
            // },
            // {
            //    value: '',
            //    key: '3PLRef',
            //    label: 'reference_3pl',
            //    primary: false,
            //    otro: true,
            // },
            // {
            //    value: '',
            //    key: 'Carrier',
            //    label: 'carrier',
            //    primary: false,
            //    otro: true,
            // },
            {
               value: '',
               key: 'Voyage_FlightNumber',
               label: 'shipmen_detail_summary_general_train_no',
               primary: false,
               otro: true,
            },
            {
               value: '',
               key: 'DutyPaidDate',
               label: 'duty_paid_date',
               primary: false,
               otro: true,
            },
            {
               value: '',
               key: 'EntryNumber',
               label: 'entry_number',
               primary: false,
               otro: true,
            }, 
            {
               value: '',
               key: 'DaysInTransit',
               label: 'days_in_transit',
               primary: false,
               otro: true,
            },
            {
               value: '',
               key: 'AscertainedTotal',
               label: 'ascertained_total',
               primary: false,
               otro: true,
            }
         ]
      },
      {
         label: 'cargo',
         data: [
            {
               value: '',
               key: 'TotalWeight',
               label: 'chargable_weight',
               primary: false,
               otro: false,
               format: 'weight'
            },
            {
               value: '',
               key: 'TotalGrossWeight',
               label: 'gross_weight',
               primary: false,
               otro: false,
               format: 'weight'
            },
            {
               value: '',
               key: 'TotalVolume',
               label: 'total_volume',
               primary: false,
               otro: false,
               format: 'dimension'
            },
            {
               value: '',
               key: 'DeclaredValue',
               label: 'shipment_total_value',
               primary: false,
               otro: false
            },
            {
               value: '',
               key: 'declaredValueCurrency',
               label: 'currency',
               primary: false,
               otro: false
            },
            {
               value: '',
               key: 'Totalpieces',
               label: 'total_píeces',
               primary: false,
               otro: false
            },
            {
               value: '',
               key: 'TotalPackages',
               label: 'total_amount_packages',
               primary: false,
               otro: false
            },
            {
               value: '',
               key: 'DGR',
               label: 'dgr',
               primary: false,
               otro: true,
            },
            {
               value: '',
               key: 'UN',
               label: 'UN',
               primary: false,
               otro: true,
            },
            {
               value: '',
               key: 'Class',
               label: 'class',
               primary: false,
               otro: true,
            }
         ]
      }
   ],
}

export default mapJson
